import Cell from '@puzzleapps/shared/src/store/models/Cell'

export default class CrosswordCell extends Cell
{
  constructor()
  {
    super()
    this._words = {
      across: '',
      down: '',
    }
    this._isBlack = true
    this._clueNumber = 0 // cells with a clue number are the first letter of a word
    this._solution = ''
    this._clues =  {
      across: null,
      down: null,
    }
  }

  get input() { return this._input }
  set input(input) {
    if (this._isBlack) return
    this._input = input 
  }
  
  get solution() { return this._solution }
  set solution(solution) { this._solution = String(solution) }

  get words() { return this._words }
  set words(words) { this._words = words }

  get isBlack() { return this._isBlack }
  set isBlack(isBlack) { this._isBlack = Boolean(isBlack) }

  get clueNumber() { return this._clueNumber }
  set clueNumber(clueNumber) { this._clueNumber = Number(clueNumber) }

  get clues() { return this._clues }
  // set clues(clues) { this._clues = clues }

  hasAcrossWord() {
    return this._words.across !== ''
  }

  hasDownWord() {
    return this._words.down !== ''
  }

  isCorrect() {
    if (this._isBlack) return true      
    else return this._input === this._solution
  }

  isBlank(){
    return this._input === 0
  }

  cellIsCorrect(){
    return this._input === this._solution
  }



}

